export const sortNumber = (a, b) => a - b;

/**
 * @param keys An array of object keys to be sorted by
 * @description Sort function to sort an object by one or more keys
 * @example
 *
 * const persons = [{ 'name': 'Joey', 'age': 30 }, { 'name': 'Andrew', 'age': 30 }, { 'name': 'Paul', 'age': 25 }]
 *
 * persons.sort(compareKeys(['name','age']))
 * // [ { 'name': 'Andrew', 'age': 30 }, { 'name': 'Joey', 'age': 30 }, { 'name': 'Paul', 'age': 25 }]
 *
 * persons.sort(compareKeys(['age','name']))
 * // [{ 'name': 'Paul', 'age': 25 }, { 'name': 'Andrew', 'age': 30 }, { 'name': 'Joey', 'age': 30 }]
 */
export const compareKeys = keys => (a, b) => {
  let comparison = 0;
  keys.forEach(key => {
    if (comparison === 0) {
      if (!a.hasOwnProperty(key) || a[key] === null) {
        a[key] = '';
      }
      if (!b.hasOwnProperty(key) || b[key] === null) {
        b[key] = '';
      }
      const valueA = typeof a[key] === 'string' ? a[key].toUpperCase() : +a[key];
      const valueB = typeof b[key] === 'string' ? b[key].toUpperCase() : +b[key];

      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }
    }
  });

  return comparison;
};
